export enum TourScheduleType {
  fixed = 1,
  seasons = 2
};